import { Fragment, type ComponentType, type ReactElement } from 'react';
import { Button, Menu, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger, makeStyles, tokens } from '@coreai/fluentui-react';
import { MoreHorizontal20Regular } from '@fluentui/react-icons';

export type OverflowMenuItem = {
  label: string;
  icon?: ComponentType;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
  /** Show a divider before this item */
  dividerBefore?: boolean;
};

type OverflowMenuProps = {
  items: readonly OverflowMenuItem[];
};

const useStyles = makeStyles({
  dangerItem: {
    color: tokens.colorPaletteRedForeground1,
  },
});

export const ActionMenuItems = ({ items }: OverflowMenuProps) => {
  const styles = useStyles();

  return (
    <MenuList>
      {items.map((item) => (
        <Fragment key={item.label}>
          {item.dividerBefore && <MenuDivider />}
          <MenuItem
            onClick={item.onClick}
            {...(item.icon ? { icon: <item.icon /> } : {})}
            {...(item.disabled ? { disabled: true } : {})}
            {...(item.danger ? { className: styles.dangerItem } : {})}
          >
            {item.label}
          </MenuItem>
        </Fragment>
      ))}
    </MenuList>
  );
};

export const OverflowMenu = ({ items }: OverflowMenuProps) => (
  <Menu>
    <MenuTrigger disableButtonEnhancement>
      <Button
        appearance="subtle"
        icon={<MoreHorizontal20Regular />}
        aria-label="More actions"
        onClick={(event) => event.stopPropagation()}
      />
    </MenuTrigger>
    <MenuPopover>
      <ActionMenuItems items={items} />
    </MenuPopover>
  </Menu>
);

interface ContextActionsMenuProps extends OverflowMenuProps {
  children: ReactElement;
}

export const ContextActionsMenu = ({
  children,
  items,
}: ContextActionsMenuProps) => (
  <Menu openOnContext>
    <MenuTrigger disableButtonEnhancement>{children}</MenuTrigger>
    <MenuPopover>
      <ActionMenuItems items={items} />
    </MenuPopover>
  </Menu>
);
